import { ProgramService } from '@modules/program/program-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';

export class ProgramField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/program',
      Permissions.values.programRead,
      ProgramService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.label,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/program',
      Permissions.values.programRead,
      ProgramService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.label,
        };
      },
      options,
    );
  }
}
